export default "__VITE_ASSET__Qd4uDjqk__"